import { useTranslation } from 'react-i18next'

import { FieldStackedLabel } from '../../../Field'
import { FormikField, getFormikFormFieldErrorProps } from '../../../Formik'
import { InputField } from '../../../Input'
import {
  USER_INVITATION_FORM_FIELD_NAME_SUBJECT,
  USER_INVITATION_FORM_SUBJECT_FIELD_MAX_LENGTH,
} from '../UserInvitationForm.constants'

import * as styles from './UserInvitationFormSubjectField.module.css'

function UserInvitationFormSubjectField() {
  const { t } = useTranslation()

  return (
    <FormikField
      clearable
      Component={InputField}
      Field={FieldStackedLabel}
      fieldComponentProps={{
        className: styles.subject,
        label: `${t('User.InvitationSubjectLabelKey')}:`,
      }}
      getErrorProps={getFormikFormFieldErrorProps}
      maxLength={USER_INVITATION_FORM_SUBJECT_FIELD_MAX_LENGTH}
      name={USER_INVITATION_FORM_FIELD_NAME_SUBJECT}
      placeholder={t('Email.SubjectPlaceholderKey')}
    />
  )
}

export default UserInvitationFormSubjectField
